













































import Breadcrum, { BreadcrumItem } from '@/components/Breadcrum.vue';
import Dropdown, { DropdownItem } from '@/components/Dropdown.vue';
import Header from '@/components/Header.vue';
import Icon from '@/components/Icon.vue';
import NetworkIndicator from '@/components/NetworkIndicator.vue';
import Sidebar, { MenuLink } from '@/components/Sidebar.vue';
import ModalVersion from '@/components/ModalVersion.vue';
import {
    Component,
    Vue,
    Watch,
    Prop,
} from 'vue-property-decorator';
import UserInfo from '@/core/userinfo';

@Component({
    components: {
        Breadcrum,
        Dropdown,
        Header,
        Icon,
        NetworkIndicator,
        Sidebar,
        ModalVersion,
    },
})
export default class App extends Vue {
    @Prop(UserInfo) readonly userinfo!: UserInfo;

    breadcrumLevels: Array<BreadcrumItem> = [
        { name: 'Panel', url: '#' },
    ]

    menuLinks: Array<MenuLink> = []

    dropdownItems: Array<DropdownItem> = [
        {
            name: 'Version',
            icon: 'information-circle',
            iconFilled: true,
            action: () => { this.openVersionModal(); },
        },
        {
            name: 'Salir',
            icon: 'logout',
            iconFilled: true,
            action: () => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                this.$auth.logout({
                    returnTo: window.location.origin,
                });
                sessionStorage.setItem('token', '');
            },
        },
    ]

    @Watch('isAuthLoading')
    onIsAuthChanged() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        if (!this.$auth.loading && this.$auth.isAuthenticated) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            this.$auth.getTokenSilently().then((token) => {
                sessionStorage.setItem('token', token);
            });
        }
    }

    @Watch('userinfo')
    onUserInfoChange() {
        this.setMenuLinks();
    }

    @Watch('$route')
    onRouteChange() {
        // Update menu selections when route changes
        this.setMenuLinks();
    }

    get isAuthLoading() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return this.$auth.loading;
    }

    mounted() {
        this.setMenuLinks();
    }

    setMenuLinks() {
        // Get current route path to determine which menu item should be selected
        const currentPath = this.$route.path;

        this.menuLinks = [
            {
                title: 'Panel',
                url: '/panel',
                selected: currentPath === '/panel',
                icon: 'home',
            },
            {
                title: 'Analíticas',
                url: '/panel/analytics',
                selected: currentPath === '/panel/analytics',
                icon: 'analytics',
            },
        ];

        // Panorama Global
        this.menuLinks.push({
            title: 'Panorama',
            url: '/panel/panorama',
            selected: currentPath === '/panel/panorama',
            icon: 'status-online',
        });

        this.menuLinks.push({
            title: 'Auditoria',
            url: '/panel/audit',
            selected: currentPath === '/panel/audit',
            icon: 'history',
            iconFilled: true,
            iconViewBox: '0 0 24 24',
        });

        const canSeeCallsByAgent = this.userinfo.customers.some(
            (customer) => customer.domain === 'vip2pbx.myflexpbx.com'
            || customer.domain === 'biomax1.myflexpbx.com'
            || customer.domain === 'biomax2.myflexpbx.com'
            || customer.domain === 'biomax3.myflexpbx.com'
            || customer.domain === 'cloudpbxclient1.picallex.com',
        );

        if (canSeeCallsByAgent) {
            this.addLinkCallsByAgent();
        }

        // siempre ultimo: es una herramienta de diagnostico, no de operacion
        this.menuLinks.push({
            title: 'Red',
            url: '/panel/network',
            selected: currentPath === '/panel/network',
            icon: 'wifi',
        });
    }

    addLinkCallsByAgent() {
        const currentPath = this.$route.path;
        this.menuLinks.push({
            title: 'Agent',
            url: '/panel/agent',
            selected: currentPath === '/panel/agent',
            icon: 'bot',
        });
    }

    toogleSidebar() {
        const sidebar = this.$refs.sidebar as Sidebar;
        sidebar.toogleMobile();
    }

    openVersionModal() {
        (this.$refs.modalVersion as ModalVersion).toogle();
    }

    updateSelectedMenu(index: number) {
        this.menuLinks.forEach((menu, i) => {
            // eslint-disable-next-line no-param-reassign
            menu.selected = i === index;
        });

        const selectedMenu = this.menuLinks[index];
        if (selectedMenu) {
            this.breadcrumLevels = [{ name: selectedMenu.title, url: selectedMenu.url }];
        }
    }
}
